import { object, string } from 'yup';

import { messages } from './blacklist-address-schema-messages';
import { buildMessageCallback } from '../validation/utilities';

/**
 * Yup schema for validating blacklist addresses
 * Required fields: line1, city, state, postalCode
 * Note: countryCode is optional for backward compatibility but recommended
 */
export const blacklistAddressSchema = object({
  line1: string().trim().required(buildMessageCallback(messages.addressLine1Required)),
  city: string().trim().required(buildMessageCallback(messages.cityRequired)),
  state: string().trim().required(buildMessageCallback(messages.stateRequired)),
  postalCode: string().trim().required(buildMessageCallback(messages.postalCodeRequired)),
  countryCode: string().nullable(),
  line2: string().nullable(),
  reason: string().nullable(),
  blacklistedAddressID: string().nullable(),
  referenceOrderId: string().nullable(),
});

/**
 * Yup schema for adding new blacklist entries
 * Requires countryCode in addition to other required fields
 */
export const addBlacklistEntrySchema = object({
  line1: string().trim().required(buildMessageCallback(messages.addressLine1Required)),
  city: string().trim().required(buildMessageCallback(messages.cityRequired)),
  state: string().trim().required(buildMessageCallback(messages.stateRequired)),
  postalCode: string().trim().required(buildMessageCallback(messages.postalCodeRequired)),
  countryCode: string().trim().required(buildMessageCallback(messages.countryCodeRequired)),
  line2: string().nullable(),
  reason: string().max(500, buildMessageCallback(messages.reasonMaxLength)).nullable(),
});

/**
 * Yup schema for updating a blacklist entry
 */
export const updateBlacklistEntrySchema = object({
  line1: string().trim().required(buildMessageCallback(messages.addressLine1Required)),
  city: string().trim().required(buildMessageCallback(messages.cityRequired)),
  state: string().trim().required(buildMessageCallback(messages.stateRequired)),
  postalCode: string().trim().required(buildMessageCallback(messages.postalCodeRequired)),
  countryCode: string().trim().required(buildMessageCallback(messages.countryCodeRequired)),
  line2: string().nullable(),
  reason: string().max(500, buildMessageCallback(messages.reasonMaxLength)).nullable(),
});
